module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/stat/chart.component.html
// module id = 934
// module chunks = 0